module.exports = __webpack_public_path__ + "static/poster-fb077cf26d71283da3412551d7575e75.jpg";